/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CarePrincipalDTO,
    CarePrincipalDTOFromJSON,
    CarePrincipalDTOToJSON,
} from '../models';

export interface AddCarePrincipalRequest {
    carePrincipalDTO: CarePrincipalDTO;
}

export interface GetCarePrincipalRequest {
    carePrincipalId: string;
}

export interface GetCarePrincipalsForAuthorizedEntityRequest {
    authorizedEntity: string;
}

export interface RemoveCarePrincipalRequest {
    carePrincipalId: string;
}

export interface UpdateCarePrincipalRequest {
    carePrincipalId: string;
    carePrincipalDTO: CarePrincipalDTO;
}

/**
 * 
 */
export class CarePrincipalApi extends runtime.BaseAPI {

    /**
     */
    async addCarePrincipalRaw(requestParameters: AddCarePrincipalRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.carePrincipalDTO === null || requestParameters.carePrincipalDTO === undefined) {
            throw new runtime.RequiredError('carePrincipalDTO','Required parameter requestParameters.carePrincipalDTO was null or undefined when calling addCarePrincipal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CarePrincipalDTOToJSON(requestParameters.carePrincipalDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async addCarePrincipal(carePrincipalDTO: CarePrincipalDTO, initOverrides?: RequestInit): Promise<void> {
        await this.addCarePrincipalRaw({ carePrincipalDTO: carePrincipalDTO }, initOverrides);
    }

    /**
     */
    async getAllCarePrincipalsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<CarePrincipalDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipals`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CarePrincipalDTOFromJSON));
    }

    /**
     */
    async getAllCarePrincipals(initOverrides?: RequestInit): Promise<Array<CarePrincipalDTO>> {
        const response = await this.getAllCarePrincipalsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getCarePrincipalRaw(requestParameters: GetCarePrincipalRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CarePrincipalDTO>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling getCarePrincipal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/{carePrincipalId}`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CarePrincipalDTOFromJSON(jsonValue));
    }

    /**
     */
    async getCarePrincipal(carePrincipalId: string, initOverrides?: RequestInit): Promise<CarePrincipalDTO> {
        const response = await this.getCarePrincipalRaw({ carePrincipalId: carePrincipalId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCarePrincipalsForAuthorizedEntityRaw(requestParameters: GetCarePrincipalsForAuthorizedEntityRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<CarePrincipalDTO>>> {
        if (requestParameters.authorizedEntity === null || requestParameters.authorizedEntity === undefined) {
            throw new runtime.RequiredError('authorizedEntity','Required parameter requestParameters.authorizedEntity was null or undefined when calling getCarePrincipalsForAuthorizedEntity.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipals/authorizedentity/{authorizedEntity}`.replace(`{${"authorizedEntity"}}`, encodeURIComponent(String(requestParameters.authorizedEntity))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CarePrincipalDTOFromJSON));
    }

    /**
     */
    async getCarePrincipalsForAuthorizedEntity(authorizedEntity: string, initOverrides?: RequestInit): Promise<Array<CarePrincipalDTO>> {
        const response = await this.getCarePrincipalsForAuthorizedEntityRaw({ authorizedEntity: authorizedEntity }, initOverrides);
        return await response.value();
    }

    /**
     */
    async removeCarePrincipalRaw(requestParameters: RemoveCarePrincipalRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling removeCarePrincipal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/{carePrincipalId}`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async removeCarePrincipal(carePrincipalId: string, initOverrides?: RequestInit): Promise<void> {
        await this.removeCarePrincipalRaw({ carePrincipalId: carePrincipalId }, initOverrides);
    }

    /**
     */
    async updateCarePrincipalRaw(requestParameters: UpdateCarePrincipalRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling updateCarePrincipal.');
        }

        if (requestParameters.carePrincipalDTO === null || requestParameters.carePrincipalDTO === undefined) {
            throw new runtime.RequiredError('carePrincipalDTO','Required parameter requestParameters.carePrincipalDTO was null or undefined when calling updateCarePrincipal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/{carePrincipalId}`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CarePrincipalDTOToJSON(requestParameters.carePrincipalDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateCarePrincipal(carePrincipalId: string, carePrincipalDTO: CarePrincipalDTO, initOverrides?: RequestInit): Promise<void> {
        await this.updateCarePrincipalRaw({ carePrincipalId: carePrincipalId, carePrincipalDTO: carePrincipalDTO }, initOverrides);
    }

}
